import { AlarmTable } from "portal/components/AlarmTable";
import { NoScroll } from "portal/components/Page";
import { portalApi } from "portal/state/portalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useJigsawMetrics } from "../../utils/hooks/useJigsawMetrics";
import { useParams } from "react-router-dom";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { FunctionComponent } from "react";

const _RobotAlarmList: FunctionComponent = () => {
  const { serial } = useParams();
  const { i18n } = useTranslation();
  const useJigsaw = useJigsawMetrics();

  const { data: summary } = useQueryPopups(
    portalApi.endpoints.getRobot.useQuery(
      serial ? { language: i18n.language, serial, useJigsaw } : skipToken
    )
  );

  return (
    <NoScroll>
      <AlarmTable alarms={summary?.alarmList ?? []} serial={serial} />
    </NoScroll>
  );
};

export const RobotAlarmList = withAuthenticationRequired(_RobotAlarmList);
